import { Link } from "@inertiajs/react"
import { Columns3, Table2 } from "lucide-react"

import { Button } from "@/components/ui/button"

/**
 * The table and the board are ONE product surface with a view toggle, not two
 * pages that happen to look alike — so the heading, the pending-review nudge and
 * the toggle live here and both pages render the same component.
 */
export function WorkOrderHeader({
  tablePath,
  boardPath,
  view,
  pendingReview,
  inboxPath,
}: {
  tablePath: string
  boardPath: string
  view: "table" | "board"
  pendingReview: number
  inboxPath: string
}) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div>
        <h1 className="text-2xl font-semibold">Work Orders</h1>
        <p className="text-muted-foreground mt-1 text-sm">
          Every open job on the fleet, sorted by who we&apos;ve been waiting on
          the longest.
        </p>
      </div>

      <div className="flex items-center gap-2">
        {pendingReview > 0 && (
          <Button variant="outline" size="sm" asChild>
            <Link href={inboxPath}>{pendingReview} pending review</Link>
          </Button>
        )}
        <div className="flex rounded-md border p-0.5">
          <Button
            size="sm"
            variant={view === "table" ? "secondary" : "ghost"}
            asChild
          >
            <Link href={tablePath}>
              <Table2 className="mr-1 size-4" />
              Table
            </Link>
          </Button>
          <Button
            size="sm"
            variant={view === "board" ? "secondary" : "ghost"}
            asChild
          >
            <Link href={boardPath}>
              <Columns3 className="mr-1 size-4" />
              Board
            </Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
